import React from "react";
import { label } from "../../config/constants";

/**
 * Screen 1 of the in-app forgot password flow.
 * Shows verified recovery methods (email / mobile) as checkboxes.
 * If only one method is configured it is pre-selected automatically.
 *
 * @author Sarthak Arora
 */
const SelectRecoveryMethod = ({ email, mobile, selectedMethods, onMethodChange }) => {
  const hasEmail = !!email;
  const hasMobile = !!mobile;

  const toggle = (method) => {
    if (selectedMethods.includes(method)) {
      onMethodChange(selectedMethods.filter((m) => m !== method));
    } else {
      onMethodChange([...selectedMethods, method]);
    }
  };

  return (
    <div className='recovery-method-container'>
      <p className='recovery-method-subtitle'>{label.SELECT_RECOVERY_METHOD}</p>

      <div className='recovery-method-options'>
        {hasEmail && (
          <label className='recovery-method-option' htmlFor='recovery-email'>
            <input
              type='checkbox'
              id='recovery-email'
              className='recovery-checkbox'
              checked={selectedMethods.includes("email")}
              onChange={() => toggle("email")}
            />
            <span className='recovery-method-label'>
              <strong>Email</strong> : {email}
            </span>
          </label>
        )}

        {hasMobile && (
          <label className='recovery-method-option' htmlFor='recovery-mobile'>
            <input
              type='checkbox'
              id='recovery-mobile'
              className='recovery-checkbox'
              checked={selectedMethods.includes("mobile")}
              onChange={() => toggle("mobile")}
            />
            <span className='recovery-method-label'>
              <strong>Mobile</strong> : {mobile}
            </span>
          </label>
        )}
      </div>

      <p className='recovery-contact-admin'>{label.CONTACT_ADMIN_NOTE}</p>
    </div>
  );
};

export default SelectRecoveryMethod;

